import { render } from "./EditarMenu.vue?vue&type=template&id=4edde496"
import script from "./EditarMenu.vue?vue&type=script&lang=js"
export * from "./EditarMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__